import { useApp } from '@/hooks/use-app-context';
import { ContributionBackLine } from '@/components/contribute/ContributionBackLine';

interface ModelPerformanceHeaderProps {
  model: string;
  language: string;
  currentIndex: number;
  total: number;
  currentPage?: number;
  progressPercent: number;
  onBack: () => void;
}

export function ModelPerformanceHeader({ model, language, currentIndex, total, currentPage, progressPercent, onBack }: ModelPerformanceHeaderProps) {
  const { t } = useApp();
  const tModel = t.modelPerformancePage;
  const pct = Math.round(progressPercent);

  return (
    <section className="relative py-6">
      <div className="grid gap-5 sm:grid-cols-[minmax(0,1fr)_200px] sm:items-end">
        <div>
          <ContributionBackLine label={String(t.back ?? '')} onClick={onBack} />
          <p className="mt-4 flex items-center gap-3 text-[0.68rem] font-semibold uppercase tracking-[0.28em] text-primary/70">
            {String(t.sessionValidation ?? '')}
          </p>
          <h2 className="mt-3 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
            {tModel.sessionMeta
              .replace('{language}', language)
              .replace('{model}', model)}
          </h2>
        </div>

        <div className="grid grid-cols-2 gap-0 overflow-hidden rounded-2xl border border-border/40 bg-background/60">
          <div className="min-w-0 border-r border-border/30 px-4 py-3">
            <span className="block text-[0.6rem] font-semibold uppercase tracking-[0.2em] text-muted-foreground/60">{tModel.statsAssessmentsLabel}</span>
            <span className="mt-1 block truncate text-sm font-semibold text-foreground">{currentIndex + 1} / {total}</span>
          </div>
          {currentPage !== undefined && (
            <div className="min-w-0 px-4 py-3">
              <span className="block text-[0.6rem] font-semibold uppercase tracking-[0.2em] text-muted-foreground/60">{String(tModel.pageLabel ?? '')}</span>
              <span className="mt-1 block truncate text-sm font-semibold text-foreground">{currentPage}</span>
            </div>
          )}
        </div>
      </div>

      <div className="mt-5 h-1 overflow-hidden rounded-full bg-muted/30">
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-700 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>
    </section>
  );
}
